import React from 'react';
import {createNativeStackNavigator} from '@react-navigation/native-stack';
import WorkersTabScreen from '../screens/worker/WorkersTabScreen';
import WorkerDetailScreen from '../screens/worker/WorkerDetailScreen';
import WorkerFormScreen from '../screens/worker/WorkerFormScreen';
import TaskAssignmentDetailScreen from '../screens/worker/TaskAssignmentDetailScreen';
import WorkerRateSetupScreen from '../screens/worker/WorkerRateSetupScreen';

const Stack = createNativeStackNavigator();

const WorkerNavigator = () => {
  return (
    <Stack.Navigator screenOptions={{headerShown: false}}>
      <Stack.Screen name="WorkersTabs" component={WorkersTabScreen} />
      <Stack.Screen name="WorkerDetail" component={WorkerDetailScreen} />
      <Stack.Screen name="WorkerForm" component={WorkerFormScreen} />
      <Stack.Screen name="TaskAssignmentDetail" component={TaskAssignmentDetailScreen} />
      <Stack.Screen name="WorkerRateSetup" component={WorkerRateSetupScreen} />
    </Stack.Navigator>
  );
};

export default WorkerNavigator;
